package dev.lingvo.site.components.studio.canvas

import dev.lingvo.shared.screenshots.render.noiseTile
import kotlinx.browser.document
import org.w3c.dom.HTMLCanvasElement
import kotlin.math.roundToInt

internal fun noisePattern(ctx: dynamic, seed: Int, amount: Double): dynamic {
    val globals: dynamic = js("globalThis")
    val canvas: dynamic = if (jsTypeOf(globals.OffscreenCanvas) != "undefined") js("new OffscreenCanvas(128,128)")
        else (document.createElement("canvas") as HTMLCanvasElement).also { it.width = 128; it.height = 128 }
    val tileContext = canvas.getContext("2d")
    val image = tileContext.createImageData(128, 128)
    val tile = noiseTile(seed)
    val alpha = (amount.coerceIn(0.0, 1.0) * 255).roundToInt()
    tile.forEachIndexed { index, byte ->
        val shade = byte.toInt() and 255
        val pixel = index * 4
        image.data[pixel] = shade
        image.data[pixel + 1] = shade
        image.data[pixel + 2] = shade
        image.data[pixel + 3] = alpha
    }
    tileContext.putImageData(image, 0, 0)
    return requireNotNull(ctx.createPattern(canvas, "repeat")) { "Canvas noise pattern could not be created" }
}
